export default function getIndexOffset(dataSourceDescriptors, dataSourceDescriptor) {
  if (dataSourceDescriptors.length === 1) {
    return 0;
  }
  return dataSourceDescriptors.filter(descriptor => descriptor.index < dataSourceDescriptor.index).reduce((result, descriptor) => {
    return result + descriptor.numberOfItems;
  }, 0);
}